import { createSlice, PayloadAction } from "@reduxjs/toolkit"

// Define a type for the slice state
interface ProductState {
  productPreviewSrc: string
}

// Define the initial state using that type
const initialState: ProductState = {
  productPreviewSrc: "",
}

export const counterSlice = createSlice({
  name: "product",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setProductPreview: (state, { payload }: PayloadAction<string>) => {
      state.productPreviewSrc = payload
      return state
    },
  },
})

export const { setProductPreview } = counterSlice.actions

export default counterSlice.reducer
